import React, { useState} from 'react';
import '../../styles/Brands-p.css';


const importAll = (r) => {
  return r.keys().map(r);
};


const images = importAll(require.context('../../img/brands/generalli', false, /\.(webp|jpg|jpeg|png)$/));

const Generalli = () => {
  const [zoomedImg, setZoomedImg] = useState(null); // Estado para controlar el zoom de las imágenes

  // Función para hacer zoom en la imagen
  const handleImageClick = (image) => {
    setZoomedImg(image);
  };

  // Función para cerrar el zoom
  const handleCloseZoom = () => {
    setZoomedImg(null);
  };

  return (
    <div className="netflix-gallery">
      {/* Título y subtítulo */}
      <div className="gallery-header">
        <h1 className="gallery-title">The Human Safety Net</h1>
        <h2 className="gallery-subtitle">
          <span className="agency-title">Agencia </span>  Prójimo
        </h2>
        <h2 className="gallery-subtitle">
          <span className="agency-title">Productora </span> Filmamo
        </h2>
        <h2 className="gallery-text">The idea was taking basketball to the slums of Buenos Aires - Argentina. That's when “The Human Safety Net” and “La Caja Seguros” approached Prójimo agency with the purpose of having an unforgettable experience. Together, we thought of making an event that transmits the values of basketball by bringing families together through sports. In this event I recorded six different videos, a press photographic record and different celebrities testimonials for the social networks of THSN and La Caja Seguros.</h2>
      </div>
      {/* Galería de imágenes */}
      <div className="brands-gallery">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Brand ${index}`}
            className={`brand-img img-${index % 5}`}
            onClick={() => handleImageClick(image)} // Al hacer clic, hacemos zoom
          />
        ))}
      </div>

      {/* Imagen con zoom */}
      {zoomedImg && (
        <div className="zoom-overlay" onClick={handleCloseZoom}>
          <img src={zoomedImg} alt="Zoomed" className="zoomed-img" />
        </div>
      )}
    </div>
  );
};

export default Generalli;
